<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_5"></a><em><strong>Contents</strong></em></h2>
<p class="centerx"><img alt="Image" src="images/arrow.jpg"/></p>
<p class="tocchap"> </p><p class="tocchap"><a class="nounder" href="#/xhtml/introduction#introduction"><span class="small">INTRODUCTION: GETTING BAKED, AGAIN</span></a></p>
<p class="tocchap"> </p><p class="tocchap"><a class="nounder" href="#/xhtml/everything#everything"><span class="small">EVERYTHING YOU NEED TO KNOW TO GET BAKED</span></a></p>
<p class="tocchap"> </p><p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01"><span class="small">CHAPTER 1</span><br/>BREAKFAST</a></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><span class="small">CHAPTER 2</span><br/>TARTS AND PIES</span></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><span class="small">CHAPTER 3</span><br/>COOKIES AND BARS</span></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><span class="small">CHAPTER 4</span><br/>CAKES</span></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><span class="small">CHAPTER 5</span><br/>CONFECTIONS AND PASTRY</span></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/acknowledgments#acknowledgments" title="Link target outside of Sample"><span class="small">ACKNOWLEDGMENTS</span></span></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/sources#sources" title="Link target outside of Sample"><span class="small">SOURCES</span></span></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/conversion#conversion" title="Link target outside of Sample"><span class="small">CONVERSION CHARTS</span></span></p>
<p class="tocchap"> </p><p class="tocchap"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><span class="small">INDEX</span></span></p>
<p class="pagebreak"> </p>
<p class="image"><a id="page_6"></a><img alt="Image" src="images/f0012-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?14525bb2